import Reveal from "./Reveal";
import { whatsappLink } from "../config";
import { Sprout, Flower2, HeartHandshake, Sun } from "lucide-react";

const stages = [
  {
    icon: Sprout,
    label: "Etapa 01",
    title: "Embarazo",
    desc: "Vive tu gestación con información, calma y confianza. Resolvemos tus dudas y te preparamos física y emocionalmente para recibir a tu bebé.",
  },
  {
    icon: Flower2,
    label: "Etapa 02",
    title: "Parto",
    desc: "Te acompaño en la preparación al nacimiento, tu plan de parto y las herramientas para vivirlo desde el respeto a tus decisiones.",
  },
  {
    icon: HeartHandshake,
    label: "Etapa 03",
    title: "Puerperio",
    desc: "El postparto también merece cuidado. Lactancia, recuperación, vínculo y bienestar emocional para esta etapa intensa y preciosa.",
  },
  {
    icon: Sun,
    label: "Etapa 04",
    title: "Menopausia",
    desc: "Una nueva etapa llena de sabiduría. Acompañamiento integral para vivir los cambios hormonales, físicos y sexuales con plenitud.",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-ambar/30">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <p className="font-sans text-xs tracking-[0.35em] uppercase text-terracota mb-5">
            Acompañamiento
          </p>
          <h2 className="font-serif font-light text-4xl md:text-5xl text-ciruela leading-tight tracking-tight">
            Estoy contigo en cada <span className="italic text-terracota">proceso transformador</span>
          </h2>
          <p className="font-body text-lg text-ciruela-dark/75 mt-6 leading-relaxed">
            Cada mujer y cada etapa son únicas. Por eso ofrezco un acompañamiento personalizado según el
            momento vital en el que te encuentres.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {stages.map((s, i) => (
            <Reveal key={s.title} delay={i * 90}>
              <div
                data-testid={`service-card-${s.title.toLowerCase()}`}
                className="group h-full rounded-[28px] bg-crema border border-rosa/30 p-8 hover:border-terracota/50 hover:-translate-y-1.5 transition-all duration-400"
              >
                <div className="h-14 w-14 rounded-2xl bg-rosa/30 flex items-center justify-center text-ciruela group-hover:bg-terracota group-hover:text-crema transition-colors duration-400">
                  <s.icon className="h-7 w-7" strokeWidth={1.5} />
                </div>
                <p className="font-sans text-[11px] tracking-[0.25em] uppercase text-terracota mt-7">
                  {s.label}
                </p>
                <h3 className="font-serif text-3xl text-ciruela mt-2">{s.title}</h3>
                <p className="font-body text-[15px] text-ciruela-dark/70 mt-4 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="text-center mt-14">
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="services-cta-whatsapp"
            className="inline-block font-sans font-medium rounded-full bg-terracota text-crema px-8 py-4 hover:bg-terracota-dark transition-colors duration-300"
          >
            Cuéntame en qué etapa estás
          </a>
        </Reveal>
      </div>
    </section>
  );
}
